export default __webpack_public_path__ + "static/media/character-naoshige.a99c7b21.png";